import React, { useState, useEffect } from 'react';
import Chart from "react-apexcharts";
import { useMapToggles } from '../Map/ToggleContext'; // Adjust the path as necessary
import { fixDate, fixDateGraph } from '../../helpers/helperFunctions';

const ExtendedInfoGraph = ({ type, data, height, setClickedData }) => {
    const [fecthedData, setFetchedData] = useState([])
    useEffect(() => {
        let color = "#4481EB"
        switch(type){
            case "temp":
                color = "#4481EB";
                break;
            case "humidity":
                color = "#4481EB";
                break;
            case "voltage":
                color = "#EED600";
                break;
            case "battery":
                color = "#76D33E"
                break;
            default: color =  "#4481EB"
        }
        setOptions(prevState => ({
            ...prevState,
            colors: [color],
            fill: {
                ...prevState.fill,
                colors: [color]
            }
        }));
    }, [type]);

    
    const clickFunction = (index) => {
        setClickedData(data.points[index] ?? {})
    }

    const [options, setOptions] = useState({
        chart: {
            // locales: [se, en, fi],
            //  defaultLocale: localStorage.getItem("language")==="sv" ? "se": localStorage.getItem("language") ?? "en",
            id: "Bar1",
            foreColor: getComputedStyle(document.documentElement).getPropertyValue('--main-text-color-light'),
            toolbar: {
                autoSelected: 'none',
                show: false,
            },
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: {
                    enabled: true,
                    delay: 150
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            }
        },
        // markers: {
        // size: 5,
        // colors: ["#000524"],
        // strokeColor: "#00BAEC",
        // strokeWidth: 3
        // },
        xaxis: {
            type: "datetime",
            tooltip: {
                enabled: false
            }, 
            labels: {
                formatter: (value, timestamp) => {
                    // Getting user's timezone
                    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    // Convert timestamp back to Date
                    const date = new Date(timestamp);
                    // Format date to display in user's timezone
                    return date.toLocaleTimeString('en-US', { timeZone: userTimezone, hour12: false, hour: '2-digit', minute: '2-digit' });
                }
            },
        },
        yaxis: {
            show: false,
            type: "numeric",
            tickAmount: 2,
            labels: {
                formatter: (value) => {
                    return `${value}${data.unit}`
                },
            }
        },
        tooltip: {
            enabled: true,
            theme: 'light', // Choose 'light' or 'dark', or customize further
            x: {
                show: false, // Disable the x value display in the tooltip
            },
            y: {
                formatter: function (value) {
                    return value !== null ? `${(value)}${data.unit}` : `-- ${data.unit}`
                },
                title: {
                    formatter: () => false,
                },
            },
            marker: {
                show: false, // Disable marker in tooltip
            },
            fixed: {
                enabled: false, // This can be adjusted based on your preference
            },
        },
        stroke: {
            curve: 'smooth',
            width: 2,
            dashArray: 0
        },
        colors:["#4481EB", "#000"],  
        fill: {
            colors: ["#4481EB", "#000"]
            // type: 'solid',
            // colors: ['transparent']
        },
        theme: {
            mode: 'light',
            palette: 'palette1',
            monochrome: {
                enabled: false,
                color: '#00000',
                shadeTo: 'dark',
                shadeIntensity: 0.5
            },
        },
        dataLabels: {
            enabled: false
        }
    })


    useEffect(() => {
        let maxValue = 100
        let minValue = 0
        let seriesColors = ["#76D33E"]; // Default colors for highest and lowest

        if (data) {
            if(type === "battery" || type === "voltage"){
                setFetchedData([
                    {
                        name: "Value",
                        data: data.points.map(item => ({
                            x: item.servertime,
                            y: item.value ?? null
                        })) 
                    }
                ])
                if(type === "voltage"){
                    const topValue = Math.max(
                        ...data.points.map(item => item.value).filter(v => v !== null)
                    );
                    maxValue = topValue
                    seriesColors = ["#EED600"]
                }
            }else{
                const highestSeries = data.points.map(item => ({
                    x: item.servertime,
                    y: item.value_highest ?? null
                }));
                const lowestSeries = data.points.map(item => ({
                    x: item.servertime,
                    y: item.value_lowest ?? null
                }));
                setFetchedData([
                    {
                        name: "Highest Value",
                        data: highestSeries
                    },
                    {
                        name: "Lowest Value",
                        data: lowestSeries
                    }
                ]);
                seriesColors = ["#4481EB", "#000000"]
                if(type === "temp"){
                    // Calculate max and min from series, ignoring nulls
                    const validHighest = highestSeries.map(item => item.y).filter(v => v !== null);
                    const validLowest = lowestSeries.map(item => item.y).filter(v => v !== null);
                    maxValue = Math.max(...validHighest);
                    minValue = Math.min(...validLowest);
                }
            }



            setOptions(prevState => ({
                ...prevState,
                chart: {
                    ...prevState.chart,
                    events: {
                        click: function(event, chartContext, { seriesIndex, dataPointIndex, config }) {
                            clickFunction(dataPointIndex);
                        }
                    }
                },
                xaxis: {
                    type: "datetime",
                    tooltip: { enabled: false },
                    labels: {
                        formatter: (value) => {
                            return fixDateGraph(value);
                        }
                    }
                },
                yaxis: {
                    type: "numeric",
                    tickAmount: 2,
                    max: maxValue,
                    min: minValue,
                    labels: {
                        formatter: (value) => {
                            return `${value ?? "--"}${data.unit}`
                        },
                    }
                },
                colors: seriesColors, // Setting colors for the series
                legend: {
                    show: false
                }
            }));
        }
    }, [data]);
    

    if(data?.points?.length > 0){
        return(
            <Chart
                options={options}
                series={fecthedData}
                type="area"
                height={height ? height : "100%"}
            />   
        )
    }
}

export default ExtendedInfoGraph;